import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { UserLogin } from 'src/app/models/UserLogin';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  async setObject(key: string, o: any) {
    if (o !== undefined && o !== 'undefined' && o !== null) {
      await Preferences.set({
        key,
        value: CryptoJS.AES.encrypt(JSON.stringify(o), environment.KEY_CRYPTO).toString()
      });
    } else {
      await this.removeObject(key);
    }
  }

  async getObject(key: string) {
    const result = await Preferences.get({ key });
    if (result && result.value != null && result.value !== 'undefined') {
      try {
        return JSON.parse(CryptoJS.AES.decrypt(result.value, environment.KEY_CRYPTO).toString(CryptoJS.enc.Utf8));
      } catch (err) {
        const message = JSON.stringify(err);
        await FirebaseCrashlytics.recordException({ message: message });
        return undefined;
      }
    }
    return undefined;
  }

  async setItem(key: string, value: string) {
    if (value !== undefined && value !== 'undefined' && value !== null) {
      await Preferences.set({
        key,
        value: CryptoJS.AES.encrypt(value.toString(), environment.KEY_CRYPTO).toString()
      });
    } else {
      await this.removeObject(key);
    }
  }

  async getItem(key: string) {
    const result = await Preferences.get({ key });
    if (result && result.value != null && result.value !== 'undefined') {
      try {
        return CryptoJS.AES.decrypt(result.value, environment.KEY_CRYPTO).toString(CryptoJS.enc.Utf8);
      } catch (err) {
        const message = JSON.stringify(err);
        await FirebaseCrashlytics.recordException({ message: message });
      }
    }
    return null;
  }

  async removeObject(key: string) {
    await Preferences.remove({ key });
  }

  async clear(userLogin?: UserLogin) {
    await Preferences.keys().then(
      async resp => {
        for (let i in resp.keys) {
          let key = resp.keys[i];
          if (key !== 'see_tutorial_zoom' && key !== 'INSTALLATION_DATE' && key !== 'LAST_COUNTER_UPDATE' && key !== 'USAGE_DAYS_COUNTER' && key !== 'MONTH_USAGE' && key != 'FIRST_USE' && key != 'cards_news') {
            if(key === 'auth'){
              if(userLogin != null && !userLogin.checkSession){
                Preferences.remove({key});
              }
            }else if(key === 'users_login'){
              if(userLogin != null && !userLogin.checkSession){
                const usersLogin: UserLogin [] = await this.getObject('users_login');
                if(usersLogin.length > 0){
                  usersLogin.forEach((element,index)=>{
                    if(element.userName === userLogin.userName){
                      usersLogin.splice(index,1);
                    } 
                  });
                  await this.setObject('users_login', usersLogin);
                }
              }
            }else{
              Preferences.remove({key});
            }
          }
        }
      },
      async error => {
        await Preferences.clear();
      }
    )
  }
}
